import './style.css';

import { initSite } from './init-site';

initSite();
